<template>
  <div class="f-q" id="fq">
    <div class="f-con">
      <div class="title"> <i class="fa fa-gift"></i> {{ $t('fq.p1') }}</div>
      <div class="m-r">{{ $t('fq.p2') }} <span class="gold-text">{{ $t('fq.p3') }}</span></div>
      <div class="des">{{ $t('fq.p4') }}</div>
      <div class="list">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item v-for="(item, index) in fqList" :name="index.toString()" :key="index">
            <template slot="title">
              <div class="c-title">
                <span class="no">Q0{{ index + 1 }}</span> {{ item.question }}
              </div>
            </template>
            <div class="c-con">{{ item.result }}</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>


  </div>
</template>

<script>
const fqListZH = [{
  question: '什么是 RWABS Learning Hub NFT？',
  result: 'RWABS Learning Hub NFT 是基于 BSC 区块链的数字身份凭证，代表您作为 RWA Business School 城市根节点的共建者身份。每座城市限量 2,000 份，具有稀缺性和收藏价值。持有者将获得 Web3 教育生态的专属权益。'
}, {
  question: '如何购买 NFT？',
  result: '首先，您需要安装 MetaMask 钱包并连接到 BSC 网络。确保钱包中有足够的 USDT（BEP-20）。选择新加坡节点，设置购买数量，点击"立即购买"按钮，确认交易即可完成购买。'
}, {
  question: '每个城市可以购买多少份？',
  result: '每个钱包地址在每个城市最多可以购买 50 份 NFT。这个限制是为了确保更多用户能够参与，避免单一地址过度集中持有。'
}, {
  question: '推荐佣金如何计算？',
  result: '当您推荐的用户购买 NFT 时，您将获得 20% 的直推佣金（160 USDT/份）。如果您的下级继续推荐新用户购买，您还将获得 10% 的间推佣金（80 USDT/份）。佣金将自动分配到您的钱包地址。'
}, {
  question: '推荐关系如何绑定？',
  result: '用户首次通过您的推荐链接访问网站时，推荐关系将自动绑定。该关系会在用户首次购买时写入智能合约，永久记录在区块链上，无法更改。'
}, {
  question: '为什么选择 BSC 链？',
  result: 'BSC（BNB Smart Chain）是一条高性能、低成本的区块链网络。相比以太坊主网，BSC 的交易费用更低（通常只需几美分），确认速度更快（约 3 秒），非常适合 NFT 交易场景。'
}, {
  question: '其他城市什么时候开放？',
  result: '目前已开放新加坡国际节点。其他城市将根据项目进度逐步开放，每个城市开放时价格将递增 30%。请关注官方公告获取最新信息。'
}, {
  question: '购买后可以转让吗？',
  result: '是的，RWABS NFT 符合 ERC-1155 标准，您可以在支持该标准的 NFT 市场（如 OpenSea、Element 等）自由交易转让。'
},]
const fqListEn = [{
  question: 'What is RWABS Learning Hub NFT?',
  result: 'RWABS Learning Hub NFT is a digital identity certificate based on BSC blockchain, representing your status as a co-builder of RWA Business School city root node. Each city is limited to 2,000 units with scarcity and collectible value. Holders will receive exclusive benefits in the Web3 education ecosystem.'
}, {
  question: 'How to purchase NFT?',
  result: 'First, you need to install MetaMask wallet and connect to BSC network. Ensure you have enough USDT (BEP-20) in your wallet. Select Singapore node, set purchase quantity, click "Buy Now" button, and confirm the transaction to complete your purchase.'
}, {
  question: 'How many can I buy per city?',
  result: 'Each wallet address can purchase up to 50 NFTs per city. This limit ensures more users can participate and prevents excessive concentration of holdings by a single address.'
}, {
  question: 'How is referral commission calculated?',
  result: `When your referred user purchases NFT, you'll receive 20% direct referral commission (160 USDT/unit). If your referral continues to refer new users, you'll also receive 10% indirect referral commission (80 USDT/unit). Commission is automatically distributed to your wallet address.`
}, {
  question: 'How is referral relationship bound?',
  result: `When a user first visits the website through your referral link, the referral relationship is automatically bound. This relationship is written to the smart contract upon the user's first purchase, permanently recorded on the blockchain and cannot be changed.`
}, {
  question: 'Why choose BSC chain?',
  result: 'BSC (BNB Smart Chain) is a high-performance, low-cost blockchain network. Compared to Ethereum mainnet, BSC has lower transaction fees (usually just a few cents) and faster confirmation speed (about 3 seconds), making it ideal for NFT trading scenarios.'
}, {
  question: 'When will other cities open?',
  result: 'Currently, Singapore international node is open. Other cities will gradually open according to project progress, with price increasing 30% at each city opening. Please follow official announcements for the latest information.'
}, {
  question: 'Can I transfer after purchase?',
  result: 'Yes, RWABS NFT complies with ERC-1155 standard. You can freely trade and transfer on NFT marketplaces that support this standard (such as OpenSea, Element, etc.).'
},]
export default {
  name: 'FQ',
  data() {
    return {
      activeName: '',
      fqList: fqListZH,
    };
  },
  watch: {
    '$i18n.locale'() {

      this.getList()
    }
  },
  methods: {
    getList() {
      if (this.$i18n.locale === 'zh-CN') {
        this.fqList = fqListZH
      } else {
        this.fqList = fqListEn
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
@import './h5-style.scss';
</style>
